import React,{useState,useMemo} from 'react';
import './HelpAndFAQTopicsDashboard.css';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { createBreadCrumbProps, useEffectOnce } from '../../../globalUtils/globalHooks';
import { startCase } from 'lodash';
import { CustomBreadCrumbs } from '../../../globalUtils/globalExports';
import { Icon } from '../../../globalUtils/globalIcons';
import articlesMenu from './helpAndFAQData/articles-menu.json';




const HelpAndFAQTopicsDashboard: React.FC = ()=>{
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const queryParams = new URLSearchParams(location.search);
    const topic = queryParams?.get('topic')?.trim()?.toLowerCase();
    const helpAndFaqTopics = Object.values(articlesMenu);
    const [selectedTopic,setSelectedTopic] = useState<string | undefined>(topic);
    const [helpAndFaqTopicPagesList,setHelpAndFaqTopicPagesList] = useState<[{[key:string]:string}] | null>(null);

     const breadCrumbArray = useMemo(()=>createBreadCrumbProps(
            {
                breadCrumbProps: [
                    {
                        objectType: 'link',
                        id: 'supportCentre',
                    },
                    {
                        objectType: 'link',
                        id: 'helpAndFaq'
                    },
                    {
                        objectType: 'text',
                        id: 'text',
                        text: startCase(selectedTopic)
                    }
                ]
            }
        ),[selectedTopic])

    useEffectOnce(()=>{
        if(!topic)navigate('/dashboard');
        if(topic)setHelpAndFaqTopicPagesList(articlesMenu[topic?.split(' ')?.join('-')]?.guides);
    })

    const handleTopicListItemClicked = (topic:string)=>{
        const params = new URLSearchParams(searchParams);
        params.set('topic', topic);
        setSelectedTopic(topic);
        setSearchParams(params);
        setHelpAndFaqTopicPagesList(articlesMenu[topic?.split(' ')?.join('-')]?.guides);
    }

    const handlePageItemClicked = (pageTopic:string)=>{
        navigate(`/help-and-faq/${selectedTopic}?article=${pageTopic}`,
            {
                state:{
                    topic:selectedTopic
                }
            }
        )
    }

    // const helpAndFaqTopicPagesList = [
    //     {
    //         id:'add-new-charger',
    //         header:'Add New Charger',
    //         description:'simultaneously a company, a platform, an SDK provider, and a product.Company : As a company, Helpshift is a B2B service provide...',
    //         onclick:()=>{}
    //     },
    //     {
    //         id:'edit-charger-details',
    //         header:'Edit Charger Details',
    //         description:'primarily to meet the needs of consumers, and secondarily to meet the business needs of B2C firms. Being purpo... ',
    //         onclick:()=>{}
    //     },
    //     {
    //         id:'understanding-charger-dashboard',
    //         header:'Understanding Charger Dashboard',
    //         description:' subscription include:saving time and money by automating routine support operations empowering customer serv...',
    //         onclick:()=>{}
    //     },
    //     {
    //         id:'faq',
    //         header:'FAQ',
    //         description:'erns recur widely throughout administrator- facing, supervisor-facing, and agent-fac...',
    //         onclick:()=>{}
    //     },
    // ]

    
    return (
        <div className='help__and__faq__topics__dashboard__wrap'>
            <div className='help__and__faq__topics__dashboard__container'>
                <div className='help__and__faq__topics__dashboard__header-container'>
                    <div className='help__and__faq__topics__dashboard__header'>
                        <div className='help__and__faq__topics__dashboard__header-left'>
                            <div className='help__and__faq__topics__dashboard__header-bread-crumb-container'>
                                <CustomBreadCrumbs breadCrumbs={breadCrumbArray} />
                            </div>
                            <div className='help__and__faq__topics__dashboard__header__heading-container'>
                                <div className='help__and__faq__topics__dashboard__header__heading'>
                                    {startCase(selectedTopic)}
                                </div>
                            </div>
                        </div>
                        <div className='help__and__faq__topics__dashboard__header-right'>
                            <Icon iconClassName='rms__support__centre__help__and__faq-header-icon' />
                        </div>
                    </div>
                </div>
                <div className='help__and__faq__topics__dashboard__body-container'>
                    <div className='help__and__faq__topics__dashboard__body-left-container'>
                        <div className='help__and__faq__topics__dashboard__body-topics-list-header'>
                            Sections
                        </div>
                        <div className='help__and__faq__topics__dashboard__body-topics-list-container'>
                            {
                                helpAndFaqTopics && helpAndFaqTopics?.length > 0 && helpAndFaqTopics?.map(item=>{
                                 return (
                                    <div 
                                    key={item?.id} 
                                    className={selectedTopic === item?.label?.toLowerCase() ?'help__and__faq__topics__dashboard__body-topics-selected-list-item' :'help__and__faq__topics__dashboard__body-topics-list-item'}
                                    onClick={()=>handleTopicListItemClicked(item?.label?.toLowerCase())}
                                    >
                                        {item?.label}
                                    </div>
                                 )   
                                })
                            }
                        </div>
                    </div>
                    <div className='help__and__faq__topics__dashboard__body-right-container'>
                        {
                            helpAndFaqTopicPagesList && helpAndFaqTopicPagesList?.length > 0 && helpAndFaqTopicPagesList.map(item=>{
                                return (
                                    <div 
                                        key={item?.id}
                                        className='help__and__faq__topics__dashboard__body-topic-pages-list-item'
                                        onClick={()=>{handlePageItemClicked(item?.id)}}
                                    >
                                        <div className='help__and__faq__topics__dashboard__body-topic-pages-list-item-header'>
                                            {item?.label}
                                        </div>
                                        <div className='help__and__faq__topics__dashboard__body-topic-pages-list-item-description'>
                                            {item?.description}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='help__and__faq__topics__dashboard-background-icon'>
                <Icon iconClassName='rms__support__centre__help__and__faq-background-icon' />
            </div>
        </div>
    )
}



export default HelpAndFAQTopicsDashboard;

